// removed by extract-text-webpack-plugin
module.exports = {"field":"RadioTemplate__field___1xv8T"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/RadioTemplate.less
 ** module id = 769
 ** module chunks = 0
 **/